import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, hasAnyRequiredActionsInAnySpace, NO_ACCESS_MESSAGE } from "utils/access";
import { Action } from "types/generated";

const CREATE_INTENT_PROJECT_ACCESS_TYPES = [Action.SpaceAdmin, Action.IntentProjectCreate];

/**
 * Hook that returns whether current user can create intent projects.
 * User needs to have SpaceAdmin or IntentProjectCreate actions in at least one space.
 * @returns {AccessResult} Object indicating if user can create intent projects and a message if not
 */
const useCanCreateIntentProject = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = hasAnyRequiredActionsInAnySpace(CREATE_INTENT_PROJECT_ACCESS_TYPES, viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateIntentProject;
